import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FilterIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FilterIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.3867 11.1921C4.97085 11.1921 4.63345 10.8547 4.63345 10.4388V4.78207C4.63345 4.36622 4.97085 4.02882 5.3867 4.02882C5.80256 4.02882 6.13996 4.36622 6.13996 4.78207V10.4388C6.13996 10.8547 5.80256 11.1921 5.3867 11.1921Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0184 19.9698C11.6025 19.9698 11.2651 19.6324 11.2651 19.2165V11.9993C11.2651 11.5834 11.6025 11.246 12.0184 11.246C12.4342 11.246 12.7716 11.5834 12.7716 11.9993V19.2165C12.7716 19.6324 12.4342 19.9698 12.0184 19.9698Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0002 9.43646C11.5844 9.43646 11.247 9.09906 11.247 8.6832V4.78206C11.247 4.36621 11.5844 4.02881 12.0002 4.02881C12.4161 4.02881 12.7535 4.36621 12.7535 4.78206V8.6832C12.7535 9.09906 12.4161 9.43646 12.0002 9.43646Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.6501 12.9477C18.2342 12.9477 17.8968 12.6103 17.8968 12.1945V4.78207C17.8968 4.36622 18.2342 4.02882 18.6501 4.02882C19.0659 4.02882 19.4033 4.36622 19.4033 4.78207V12.1945C19.4033 12.6103 19.0659 12.9477 18.6501 12.9477Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.6501 19.9698C18.2342 19.9698 17.8968 19.6324 17.8968 19.2165V15.7053C17.8968 15.2894 18.2342 14.952 18.6501 14.952C19.0659 14.952 19.4033 15.2894 19.4033 15.7053V19.2165C19.4033 19.6324 19.0659 19.9698 18.6501 19.9698Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.3867 19.9698C4.97085 19.9698 4.63345 19.6324 4.63345 19.2165V13.7549C4.63345 13.3391 4.97085 13.0017 5.3867 13.0017C5.80256 13.0017 6.13996 13.3391 6.13996 13.7549V19.2165C6.13996 19.6324 5.80256 19.9698 5.3867 19.9698Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.01966 14.313H2.75325C2.3374 14.313 2 13.9756 2 13.5597C2 13.1439 2.3374 12.8065 2.75325 12.8065H8.01966C8.43552 12.8065 8.77292 13.1439 8.77292 13.5597C8.77292 13.9756 8.43552 14.313 8.01966 14.313Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.6332 9.63164H9.3668C8.95094 9.63164 8.61355 9.29424 8.61355 8.87838C8.61355 8.46253 8.95094 8.12513 9.3668 8.12513H14.6332C15.0491 8.12513 15.3865 8.46253 15.3865 8.87838C15.3865 9.29424 15.0491 9.63164 14.6332 9.63164Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2467 16.0686H15.9803C15.5645 16.0686 15.2271 15.7312 15.2271 15.3154C15.2271 14.8995 15.5645 14.5621 15.9803 14.5621H21.2467C21.6626 14.5621 22 14.8995 22 15.3154C22 15.7312 21.6626 16.0686 21.2467 16.0686Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FilterIcon;
